// TO DO: Update to use AuthSlice
import React, { createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "../store/store";
import { RootState } from "../store/store";
import { login, logout, checkAuthentication } from "../redux/authSlice";

import { Pages } from "../shared/constants";
interface AuthContextType {
  isAuthenticated: boolean;
  userRoles: string[];
  login: () => void;
  logout: () => void;
  userName: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, userRoles, userName } = useSelector(
    (state: RootState) => state.auth,
  );

  useEffect(() => {
    console.log("Running Silent Login Check...");
    dispatch(checkAuthentication());
  }, [dispatch]);

  // Redirect to /overview after successful login
  useEffect(() => {
    if (isAuthenticated && window.location.pathname === "/") {
      console.log("User authenticated, navigating to /overview...");
      navigate(Pages.SurchargeProcessing, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        userRoles,
        login: () =>
          dispatch(login()).catch((err) => console.error(" Login failed", err)),
        logout: () =>
          dispatch(logout()).catch((err) =>
            console.error(" Logout failed", err),
          ),
        userName,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use AuthContext
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within an AuthProvider");
  return context;
};
